export const SELECTED_FILTER = 'selected-filter';
export const SELECTED_FILTERS = 'selected-filters';
export const RESET_SELECTED_FILTERS = 'reset-selected-filters';
export const SELECTED_FILTERS_WRAPPER = 'selected-filters-wrapper';